import React from "react";
import "../css/WhyChooseUs.css";
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  const features = [
    {
      id: 1,
      icon: "🎓",
      title: "Academic Excellence",
      desc: "A strong academic foundation with innovative teaching methods that help students achieve outstanding academic results.",
    },

    {
      id: 2,
      icon: "🌍",
      title: "Future Ready Learning",
      desc: "Modern teaching approach that develops creativity, confidence, leadership and 21st-century skills.",
    },

    {
      id: 3,
      icon: "🏫",
      title: "Modern Infrastructure",
      desc: "Well-equipped classrooms, science labs, library and sports facilities for complete student development.",
    },

    {
      id: 4,
      icon: "👩‍🏫",
      title: "Experienced Faculty",
      desc: "Dedicated teachers who provide personal attention and guide students towards academic and personal growth.",
    },
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <div className="why-content-wrapper">
          {}

          <div className="why-left">
            <span className="why-subtitle">WHY CHOOSE US</span>

            <h2 className="why-title">
              Building Future Leaders Through Quality Education
            </h2>

            <p className="why-text">
              Sahara Public School is one of the leading SEE schools in Nepal,
              trusted by parents for its quality education, strong academic
              foundation, modern learning environment, and value-based education
              system.
            </p>

            <p className="why-text">
              We empower students to grow with confidence, discipline,
              creativity, and the skills required to succeed in an ever-changing
              world. Our balanced approach combines academics, innovation,
              extracurricular activities, and moral values.
            </p>

            <p className="why-text">
              Sahara Public School follows the SEE curriculum with a focus on
              developing critical thinking, leadership qualities, communication
              skills, and overall personality development.
            </p>

            <p className="why-text">
              Connect with our admission team to know more about admission
              procedures, fee structure, curriculum details, and grade-wise
              availability.
            </p>

            <Link to="/admission">
              <button className="btn btn-primary">ENQUIRE NOW →</button>
            </Link>

            {}

            <div className="why-image-container">
              <img
                src="/images/campus.jpg"

                alt="Sahara Public School Campus"

                className="why-img"
              />
            </div>
          </div>

          {}

          <div className="why-right">
            <div className="feature-grid">
              {features.map((item) => (
                <div className="feature-card" key={item.id}>
                  <div className="feature-icon-box">{item.icon}</div>

                  <h3>{item.title}</h3>

                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
